/** @format */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { get, omit, remove } from 'lodash';
import { listPageConfig } from 'src/config';

const initialState = {
  temporary: {},
  refresh: {},
  revokeAccount: false,
  notifications: {
    unread: 0,
    messages: []
  },
  remoteAccount: {},
  pageState: {
    view: 'list',
    tab: 'all',
    page: 0,
    rowsPerPage: listPageConfig.rowPerpage,
    filters: {
      query: '',
      actived: 'all'
    },
    sortBy: 'createdAt',
    sortDir: 'desc'
  },
  clientActive: {
    interact: false
  },
  cancelRequireZaloPermission: false
};

export const appSlice = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    setRefesh(state, action) {
      state.refresh = { ...state.refresh, ...action.payload };
    },
    resetPageState: (state) => {
      state.pageState = initialState.pageState;
    },
    resetPageStateForNewData: (state) => {
      state.pageState = { ...state.pageState, page: initialState.pageState.page, filters: initialState.pageState.filters };
    },
    changePageState: (state, action) => {
      state.pageState = { ...state.pageState, ...action.payload };
    },
    resetFilters: (state) => {
      state.pageState.filters = initialState.pageState.filters;
    },

    changeFilters: (state, action) => {
      state.pageState.filters = { ...state.pageState.filters, ...action.payload };
    },
    removeFilter: (state, action) => {
      state.pageState.filters = omit(state.pageState.filters, action.payload);
    },
    revokeAccount(state, action) {
      state.revokeAccount = action.payload;
    },
    setNotifications(state, action) {
      state.notifications = action.payload;
    },
    removeNotification(state, action) {
      const messages = state.notifications.messages;
      remove(messages, { id: action.payload });

      state.notifications = {
        unread: state.notifications.unread > 0 ? state.notifications.unread - 1 : 0,
        messages: messages
      };
    },
    readAllNotification(state) {
      state.notifications = {
        unread: 0,
        messages: state.notifications.messages
      };
    },
    clearAllNotification(state) {
      state.notifications = {
        unread: 0,
        messages: {}
      };
    },
    setTemporary(state, action) {
      state.temporary = action.payload;
    },
    setRemoteAccount(state, action) {
      state.remoteAccount = action.payload;
    },
    clearRemoteAccount(state) {
      state.remoteAccount = initialState.remoteAccount;
    },
    setClientActiveInteract(state, action) {
      state.clientActive.interact = action.payload;
    },
    setCancelRequireZaloPermission(state, action) {
      state.cancelRequireZaloPermission = action.payload;
    }
  }
});
export const {
  setRefesh,
  resetPageState,
  resetPageStateForNewData,
  changePageState,
  resetFilters,
  changeFilters,
  removeFilter,
  setNotifications,
  removeNotification,
  readAllNotification,
  clearAllNotification,
  revokeAccount,
  setTemporary,
  setRemoteAccount,
  clearRemoteAccount,
  setClientActiveInteract,
  setCancelRequireZaloPermission
} = appSlice.actions;
export const selectRefreshs = ({ app }) => app.refresh;
export const selectRevokeAccount = ({ app }) => app.revokeAccount;
export const selectNotifications = ({ app }) => app.notifications;
export const selectTemporary = ({ app }) => app.temporary;
export const selectRemoteAccount = ({ app }) => app.remoteAccount;
export const selectClientActive = ({ app }) => app.clientActive;
export const selectClientActiveInteract = ({ app }) => app.clientActive.interact;
export const selectRefreshByKey = createSelector([selectRefreshs, (_state, key) => key], (refreshs, key) => {
  return get(refreshs, key, null);
}); //({ app }) => app.refresh;
export const selectCancelRequireZaloPermission = ({ app }) => app.cancelRequireZaloPermission;
export default appSlice.reducer;
